import "./emptyBasket.css";
import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useState } from "react";
import { fetchNewProductHomePage } from "../../../http/catalogApi";
import { Swiper, SwiperSlide } from "swiper/react";
import { priceToUserString } from "../../../http/basketApi";

const EmptyBasket = () => {
  const [product, setProduct] = useState(null);

  useEffect(() => {
    let isMounted = true;
    
    if (!product) {
      fetchNewProductHomePage(18).then((response) => {
        if (response && isMounted) {
          setProduct(response.data);
        }
      });
    }
    
    return () => {
      isMounted = false;
    };
  }, [product]);

  const targetRef = useRef();
  const sliderRef = useRef();

  const buttonLeftNew = () => {
    sliderRef.current.swiper.slidePrev();
  };
  const buttonRightNew = () => {
    sliderRef.current.swiper.slideNext();
  };

  function urlHomeSliderNewProduct(item) {
    if (!item.product) {
      return false;
    }

    if (item.product.product_url) {
      return item.product.product_url + item.code + "/";
    }

    var url = "/catalog/new-collection/";

    url += "product/" + item.code + "/";
    return url;
  }

  return (
    <>
      <div className={"root"}>
        <div className={'wrapper_container_limiter'}>
          <div className={'basket_and_order_column basket_wrapper_for_items'}>
            <h1 className={"root__title"}>В корзине пока ничего нет</h1>
            <span className={"root__text"}>
              Перейдите в{" "}
              <Link className={"root__link"} to={"/catalog"}>
                каталог
              </Link>{" "}
              для выбора товаров
            </span>
          </div>
        </div>
      </div>
      {product?.length ? (
        <div className={"slider-container"}>
          <div onClick={buttonLeftNew} className={"slider__nav_left"}>
            <img src="/files/images/icons/arrow_left.svg" alt="icon_left" />
          </div>
          <div onClick={buttonRightNew} className={"slider__nav_right"}>
            <img src="/files/images/icons/arrow_right.svg" alt="icon_right" />
          </div>

          <Swiper
            className={"slider"}
            slidesPerView="auto"
            ref={sliderRef}
            observer={true}
            spaceBetween={4}
            onObserverUpdate={(swiper) => {
              setTimeout(() => {
                swiper.update();
                swiper.emit("resize");
                swiper.updateProgress();
              }, 100);
            }}
          >
            {product.map((item, index) => (
              <SwiperSlide key={item.id}>
                <Link
                  className={"slider__slide-link"}
                  to={urlHomeSliderNewProduct(item)}
                >
                  <div
                    key={index}
                    className={"slider__slide-wrapper"}
                    ref={targetRef}
                  >
                    <img
                      ref={targetRef}
                      src={
                        process.env.REACT_APP_API_URL +
                        "uploads/images/" +
                        item.productId +
                        "/" +
                        item.id +
                        "/" +
                        "950_" +
                        item.img_preview
                      }
                      alt={
                        "Новинка " +
                        (item.name ? item.name : "") +
                        " в интернет-магазине YouWanna - "
                      }
                    />
                    {item.product.name && item.product.price ? (
                      <>
                        <span className={"slider__slide-name"}>
                          {item.product.name}
                        </span>
                        <span className={"slider__slide-price"}>
                          {priceToUserString(item.product.price) + " ₽"}
                        </span>
                      </>
                    ) : null}
                  </div>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      ) : null}
    </>
  );
};

export default EmptyBasket;
